import { createClient } from '@supabase/supabase-js'

// Try to get the URL and key from different environment variable naming conventions
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.SUPABASE_KEY || import.meta.env.SUPABASE_ANON_KEY

// Fallback to empty strings to avoid undefined errors, but log a warning
if (!supabaseUrl) {
  console.warn('Supabase URL not found in environment variables. Check your environment configuration.')
}

if (!supabaseAnonKey) {
  console.warn('Supabase key not found in environment variables. Check your environment configuration.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey) 